<template>
    <div class="wrap wrap--products">
        <main-header></main-header>

        <main class="main" role="main">
            <div v-if="portfolio" class="inner">
                <div class="interior-view-container">
                    <portfolio-view-head :portfolio="portfolio" @reload="search()"></portfolio-view-head>

                    <portfolio-view-body :portfolio="portfolio"></portfolio-view-body>

                    <portfolio-view-foot :portfolio="portfolio"></portfolio-view-foot>
                </div>
            </div>
        </main>

        <main-footer></main-footer>
    </div>
</template>

<script>
import api from "@/api";
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import PortfolioViewHead from "@/components/client/portfolio/portfolio-view-head.vue";
import PortfolioViewBody from "@/components/client/portfolio/portfolio-view-body.vue";
import PortfolioViewFoot from "@/components/client/portfolio/portfolio-view-foot.vue";
export default {
    components : {
        MainHeader,
        MainFooter,
        PortfolioViewHead,
        PortfolioViewBody,
        PortfolioViewFoot
    },
    props : {
        _portfolio : {type:String, default : ""}
    },
    data : () => {
        return {
            portfolio : null
        }
    },
    mounted() {
        this.init();
    },
    methods : {
        async init() {
            try {
                await this.search();
            }catch(error) {
                console.error(error);
            }
        },
        async search() {
            try {
                var { portfolio } = await api.v1.portfolios.getPortfolio({ _id: this._portfolio });
                this.portfolio = portfolio;
                await api.v1.portfolios.putPortfolio({ _id: this._portfolio });
            }catch(error) {
                console.error(error);
            }
        },
        // putPortfolio() {
        //     return new Promise(async (resolve,reject) => {
        //         try{
        //             await this.$http.put(`/api/v1/portfolios/portfolio/view/${this._portfolio}` , {} ,{
        //                 headers : {
        //
        //                 }
        //             });
        //         }catch(error) {
        //             reject(error);
        //         }
        //     });
        // },
        // getPortfolio() {
        //     return new Promise(async (resolve,reject) => {
        //         try{
        //             var res = await this.$http.get(`/api/v1/portfolios/portfolio/view/${this._portfolio}`, {
        //                 headers : {
        //
        //                 }
        //             });
        //
        //             this.portfolio = res.data.portfolio
        //
        //             resolve();
        //         }catch(error) {
        //             reject(error);
        //         }
        //     });
        // }
    }
}
</script>

<style lang="css" scoped>
</style>
